import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "@/components/feature/ArticleLayout";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
const articlePath = "/artykul/mobilny-usfansspreadsheet";
const articleTitle = "USFansSpreadsheet na urządzeniach mobilnych – pełny przewodnik";
const articleDesc = "USFansSpreadsheet w wersji mobilnej – pełna funkcjonalność na smartfonie i tablecie. Sprawdź, jak synchronizować dane i pracować z dowolnego miejsca.";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": articleTitle,
  "description": articleDesc,
  "author": { "@type": "Person", "name": "Anna Kowalska", "jobTitle": "Specjalista SEO" },
  "datePublished": "2026-06-10",
  "dateModified": "2026-06-24",
  "publisher": { "@type": "Organization", "name": "USFansSpreadsheet.help", "url": siteUrl },
  "mainEntityOfPage": { "@type": "WebPage", "@id": `${siteUrl}${articlePath}` },
  "inLanguage": "pl-PL"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Strona główna", "item": siteUrl },
    { "@type": "ListItem", "position": 2, "name": "Artykuły", "item": `${siteUrl}/artykul/przewodnik-usfansspreadsheet` },
    { "@type": "ListItem", "position": 3, "name": "Mobilnie" }
  ]
};

const relatedArticles = [
  { title: "Kompletny przewodnik po USFansSpreadsheet", to: "/artykul/przewodnik-usfansspreadsheet" },
  { title: "Jak korzystać z USFansSpreadsheet", to: "/artykul/jak-korzystac-usfansspreadsheet" },
  { title: "USFansSpreadsheet dla początkujących", to: "/artykul/dla-poczatkujacych" },
];

export default function ArticleMobile() {
  return (
    <>
      <PageMeta
        title={articleTitle}
        description={articleDesc}
        keywords="USFansSpreadsheet, mobilnie, smartfon, tablet, aplikacja mobilna, synchronizacja, Polska"
        canonicalPath={articlePath}
        ogType="article"
      />
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />

      <Navbar />
      <ArticleLayout title="USFansSpreadsheet na urządzeniach mobilnych – pełny przewodnik" category="Mobilnie" heroImg="https://readdy.ai/api/search-image?query=Smartphone%20and%20tablet%20side%20by%20side%20on%20a%20warm%20cream%20surface%20both%20displaying%20spreadsheet%20app%20interface%2C%20modern%20mobile%20workspace%20concept%2C%20soft%20natural%20overhead%20lighting%2C%20clean%20minimal%20composition%2C%20contemporary%20tech%20lifestyle%20photography&width=1400&height=600&seq=art-mob-hero-v2&orientation=landscape" heroImgAlt="USFansSpreadsheet mobilnie" relatedArticles={relatedArticles}>
        <p className="text-lg md:text-xl text-foreground-800 font-medium leading-relaxed"><strong>USFansSpreadsheet</strong> oferuje w pełni funkcjonalną wersję mobilną, która pozwala na zarządzanie arkuszami z dowolnego miejsca. Sprawdź, jak efektywnie korzystać z platformy na smartfonie i tablecie.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Aplikacja mobilna USFansSpreadsheet</h2>
        <p>Mobilna wersja <strong>USFansSpreadsheet</strong> zachowuje wszystkie kluczowe funkcje wersji desktopowej. Interfejs został zoptymalizowany pod kątem ekranów dotykowych, co sprawia, że praca na smartfonie jest wygodna i intuicyjna.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Synchronizacja między urządzeniami</h2>
        <p>Dzięki synchronizacji w chmurze, wszystkie zmiany wprowadzone na urządzeniu mobilnym są natychmiast dostępne na komputerze i odwrotnie. <strong>USFansSpreadsheet</strong> dba o to, abyś zawsze pracował na najnowszej wersji dokumentu.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Wskazówki do pracy mobilnej</h2>
        <p>Korzystaj z gestów dotykowych, aby szybko nawigować po arkuszu. <strong>USFansSpreadsheet</strong> wspiera popularne gesty, takie jak przeciąganie do zaznaczania czy dwukrotne stuknięcie do edycji komórki.</p>
      </ArticleLayout>
      <Footer />
    </>
  );
}